export default {
    homeMatches: [],
    homeVisitors: [],
    homeMeetings: [],
    homeMessages: [],
    homeOnline: []
};